import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionManagerService } from '../services/session-manager.service';
import { Observable, of } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionManager: SessionManagerService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      take(1),
      switchMap(user => {
        if (!user) {
          this.router.navigate(['/login']);
          return of(false);
        }

        const session = this.sessionManager.getState();
        if (session.isIdle) {
          this.sessionManager.forceLogout('idle_timeout');
          return of(false);
        }

        if (session.isExpired) {
          this.router.navigate(['/login'], { queryParams: { session_expired: '1' } });
          return of(false);
        }

        this.sessionManager.touchActivity();
        return of(true);
      })
    );
  }
}
